import React, { useEffect, useState } from 'react';
import { Table, DatePicker, Select, Button, Space, Card, Pagination, Row, notification, Tooltip } from 'antd';
import { FilterOutlined, ReloadOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { Moment } from 'moment-business-days';
import { RangeValue } from 'rc-picker/lib/interface';
import useGraficaAPI, { HomeData, HomeDataResume, HomeResumenRequest } from '../../dashboard/EstadisticasApi/useGraficaAPI';
import locale from 'antd/lib/date-picker/locale/es_ES';
import Col from 'antd/es/grid/col';
import useUnidadesProduccionAPI, { UnidadProduccion } from '../../unidades-produccion/useUnidadesProduccionAPI';
import MetricDashboard from './Metricas';
import FiltroInfracciones from '../../infracciones/components/FiltroInfracciones';
import FiltrosHome from './Filtros';
import SpinHome from './SpinHome';

const { RangePicker } = DatePicker;
const { Option } = Select;

const TablaResumen = () => {
  //VARIABLES-------------------------------------------------------------------------------
  const [filters, setFilters] = useState({
    fechaGenerada: '',
    estadoPago: null,
    municipio: null,
    tipoInfractor: null,
    tipoInfraccion: null
  });
  const api = useGraficaAPI();
  const unidadProducccionApi = useUnidadesProduccionAPI();
  const homeRequest: HomeResumenRequest = {
    fechaGeneradaDesde: '',
    fechaGeneradaHasta: '',
    estadoPago: '',
    municipio: 0,
    tipoInfractor: '',
    tipoInfraccion: '',
    pageNumber: 1,
    pageSize: 10
  };
  const [opcionesUnidadesProduccion, setOpcionesUnidadesProduccion] = useState<UnidadProduccion[]>();
  const [homeData, setHomeData] = useState<HomeData>();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
        showTotal: (total: number, range: [number, number]) =>
      `${range[0]}-${range[1]} de ${total} items`
  });
  const [dataTable, setDataTable] = useState<any>();
  const [allData, setAllData] = useState<any>();
  const tooltipTitle = {
    1: 'Total de infracciones generadas por primera vez (actas no regeneradas)',
    2: 'Total de infracciones pagadas',
    3: 'Total de infracciones paga durante el pago voluntario vigente',
    4: 'Total de infracciones paga durante el pago total vigente',
    5: 'Total de infracciones impagas',
    6: 'Total de infracciones impagas con paga voluntario vigente',
    7: 'Total de infracciones impagas con pago total vigente',
    8: 'Total de infracciones vencidas',
    9: 'Relaciones de infracciones pagas respecto del total generadas',
    10: 'Total de infracciones cuya acta fue regenerada al menos una vez'
  }
  const columns = [
    {
      title: 'Acta', dataIndex: 'numeroActa', key: 'numeroActa',
      //   sorter: (a: { id: string; }, b: { id: any; }) => a.id.localeCompare(b.id),
    },
    { title: 'Municipio', dataIndex: 'unidadProduccion', key: 'unidadProduccion' },
    { title: 'Fecha generada', dataIndex: 'fechaGenerada', key: 'fechaGenerada', render: (text: string) => dayjs(text).format("DD-MM-YYYY"), },
    { title: 'Fecha pago', dataIndex: 'fechaPago', key: 'fechaPago', render: (text: string) => text == undefined ? '-' : dayjs(text).format("DD-MM-YYYY"), },
    { title: 'Monto pago', dataIndex: 'montoPago', key: 'montoPago', render: (monto: { toLocaleString: () => any; }) => `$${monto.toLocaleString()}` },
    {
      title: 'Tipo infractor', dataIndex: 'tipoInfractor', key: 'tipoInfractor',
      render: (tipoInf: number) => <span>{tipoInf == 0 ? 'OTRO' : tipoInf == 1 ? 'EMPRESA' : tipoInf == 2 ? 'MASCULINO' : 'FEMENINO'}</span>
    },
    {
      title: 'Estado pago', dataIndex: 'estadoPago', key: 'estadoPago',
      render: (status: number) => (
        <span style={{
          padding: '4px 8px',
          borderRadius: '12px',
          backgroundColor: status === 2 ? '#52c41a' :
            status === 0 ? '#f5222d' : '#000000ff',
          color: 'white',
          fontSize: '12px'
        }}>
          {status == 0 ? 'Impaga' : 'Pagada'}
        </span>
      ),
    },
    {
      title: 'Estado vencimiento', dataIndex: 'estadoVencimiento', key: 'estadoVencimiento',
      render: (estadoVencimiento: string) => (
        <span style={{
          padding: '4px 8px',
          borderRadius: '12px',
          backgroundColor: estadoVencimiento === 'V.PV' ? '#52c41a' :
            estadoVencimiento === 'V.PT' ? '#d6ca22ff' : '#ff1b1bff',
          color: 'white',
          fontSize: '12px'
        }}>
          {estadoVencimiento.toUpperCase()}
        </span>
      ),
    },
     { title: 'Monto vencido', dataIndex: 'montoVencido', key: 'montoVencido', render: (monto: { toLocaleString: () => any; }) => `$${monto.toLocaleString()}` },
    {
      title: 'Tipo infracción', dataIndex: 'tipoInfraccion', key: 'tipoInfraccion',
      render: (tipoInfraccion: string) => (<span>{tipoInfraccion.toUpperCase()}</span>),
    }
  ];
  const [spinLoad, setSpinLoad] = useState<boolean>(false);

  //METODOS---------------------------------------------------------------------------------
  const getDataFechas = (fechas: any) => {
    if (!fechas) {
      return [undefined, undefined];
    }
    var fechaDesde = fechas[0].startOf('day').toISOString();
    var fechaHasta = fechas[1].endOf('day').toISOString();
    //var fechaFilter = `FechaHora ge ${fechaDesde/*.utc()*/.startOf("day").toISOString()} and FechaHora le ${fechaHasta/*.utc()*/.endOf("day").toISOString()}`;
    return [fechaDesde, fechaHasta];
  };

  const handleFilterChange = (key: string, value: any | RangeValue<Moment>) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handleSearch = async (page = pagination.current, size = pagination.pageSize) => {
    setSpinLoad(true);
    let fechasFilter = getDataFechas(filters.fechaGenerada)

    if (homeRequest) {
      homeRequest.estadoPago = filters.estadoPago ?? '';
      homeRequest.municipio = filters.municipio ? Number(filters.municipio) : null;
      homeRequest.tipoInfractor = filters.tipoInfractor ?? null;
      homeRequest.fechaGeneradaDesde = fechasFilter[0] ?? null;
      homeRequest.fechaGeneradaHasta = fechasFilter[1] ?? null;
      homeRequest.tipoInfraccion = filters.tipoInfraccion ?? null;
      homeRequest.pageNumber = page;
      homeRequest.pageSize = size;
    }

    //const response = await api.getHomeDataResumen(homeRequest)
    api.getHomeDataResumen(homeRequest).then((response) => {
      setAllData(response.data?.value.resumen ?? [])
      setDataTable(((response.data?.value.resumen ?? []) as HomeDataResume[]).slice(0, pagination.pageSize))
      setHomeData(response.data?.value)
      const total = response.data?.value.generadas ?? 0;
      setPagination(prev => ({ ...prev, current: 1, pageSize: 10, total: total }));
      setSpinLoad(false);
    })
    .catch((error) => {
      setSpinLoad(false);
      console.log(error)
    })

  };

  const handleReset = () => {
    setFilters({
      fechaGenerada: '',
      estadoPago: null,
      municipio: null,
      tipoInfractor: null,
      tipoInfraccion: null
    });
  };

  const handleTableChange = (newPagination: any) => {
    const { current, pageSize } = newPagination;

    const start = (current - 1) * pageSize;
    const end = start + pageSize;

    setDataTable(allData.slice(start, end));
    setPagination(prev => ({
      ...prev,
      current,
      pageSize,
      total: allData.length
    }));
  };

  useEffect(() => {
    const cargarSelectUnidadProduccion = async () => {
      await unidadProducccionApi.list({ $orderby: ['nombre'] })
        .then((data) => {
          setOpcionesUnidadesProduccion(data.data?.value);
        })
        .catch((error) => {
          notification.error({ message: 'No se pueden cargar las unidades de producción...' });
        });
    };
    cargarSelectUnidadProduccion();
  }, []);

  const handleDescargarDatos = () => {
    if (!homeData || !homeData.resumen) return;

    const csvContent = convertToCSV(homeData);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', `resumen_completo_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const convertToCSV = (data: HomeData) => {
    const sections = [];

    // Sección 1: Datos globales
    sections.push('DATOS GLOBALES');
    const globalHeaders = ['Métrica', 'Valor'];
    const globalData = [
      ['Actas Generadas', data.generadas],
      ['Actas Nuevas', data.generadasNuevas],
      ['Actas Regeneradas', data.regeneradas],
      ['Por Generar', data.porGenerar],
      ['Actas Pagadas', data.pagadas],
      ['Pago Voluntario Pagadas', data.pagasPVoluntario],
      ['Pago Total Pagadas', data.pagasPTotal],
      ['Actas Impagas', data.impagas],
      ['Pago Voluntario Impagas', data.impagasPVoluntario],
      ['Pago Total Impagas', data.impagasPTotal],
      ['Actas Vencidas', data.vencidas],
      ['Monto Pagadas', `$${data.montoPagadas}`],
      ['Monto Pago Voluntario Pagadas', `$${data.montoPagasPVoluntario}`],
      ['Monto Pago Total Pagadas', `$${data.montoPagasPTotal}`],
      ['Monto Impagas', `$${data.montoImpagas}`],
      ['Monto Pago Voluntario Impagas', `$${data.montoImpagasPVoluntario}`],
      ['Monto Pago Total Impagas', `$${data.montoImpagasPTotal}`],
      ['Monto Vencidas', `$${data.montoVencidas}`],
      ['Monto Total', `$${data.montoTotal}`],
      ['Monto Actas Nuevas', `$${data.montoGeneradasNuevas}`],
      ['Monto Actas Regeneradas', `$${data.montoRegeneradas}`],
      ['Porcentaje Pagas/Generadas', `${data.porcentajePagasGeneradas}%`]
    ];

    sections.push(globalHeaders.join(','));
    globalData.forEach(row => sections.push(row.join(',')));

    // Espacio entre secciones
    sections.push('');
    sections.push('DETALLE DE ACTAS');

    // Sección 2: Detalle de actas
    const detailHeaders = [
      'Número Acta', 'Estado Pago', 'Unidad Producción', 'Fecha Generada',
      'Fecha Pago', 'Fecha Vencimiento Pago Voluntario',
      'Fecha Vencimiento Pago Total', 'Momento Pago', 'Monto Pago',
      'Tipo Infractor', 'Estado Vencimiento', 'Tipo Infracción', 'Monto Vencido'
    ];

    sections.push(detailHeaders.join(','));

    dataTable.forEach((item: any) => {
      const row = [
        `"${item.numeroActa}"`,
        item.estadoPago,
        `"${item.unidadProduccion}"`,
        `"${item.fechaGenerada}"`,
        item.fechaPago ? `"${item.fechaPago}"` : '""',
        `"${item.fechaVencimientoPagoVoluntario}"`,
        `"${item.fechaVencimientoPagoTotal}"`,
        `"${item.momentoPago}"`,
        item.montoPago,
        item.tipoInfractor,
        `"${item.estadoVencimiento}"`,
        `"${item.tipoInfraccion}"`,
        item.montoVencido
      ];
      sections.push(row.join(','));
    });

    return sections.join('\n');
  };

  return (
    <>
      <FiltrosHome
        filters={filters}
        handleFilterChange={handleFilterChange}
        handleReset={handleReset}
        handleSearch={handleSearch}
        onDescargarDatos={handleDescargarDatos}
        opcionesUnidadesProduccion={opcionesUnidadesProduccion}
        locale={locale}
        setPagination={setPagination}
        pagination={pagination}
      />
      <MetricDashboard homeData={homeData} tooltipTitle={tooltipTitle} />
        <Table
          columns={columns}
          dataSource={dataTable}
          pagination={pagination}
          onChange={handleTableChange}
          scroll={{ x: 800 }}
          rowKey="numeroActa"
        />
      <SpinHome spinning={spinLoad} tip=''> 
      </SpinHome>

    </>
  );
};

export default TablaResumen;